import CreateServicePageComponent from "./components/CreateServicePageComponent";
import axios from "axios";
import {
  uploadImagesApiRequest,
  uploadImagesCloudinaryApiRequest,
} from "./utils/utils";
import { useSelector } from "react-redux";
import { newCategory,deleteCategory, saveAttributeToCatDoc } from "../../redux/actions/categoryActions";
import { useDispatch } from "react-redux";

const createServiceApiRequest = async (formInputs) => {
  const { data } = await axios.post(`/api/services/admin`, { ...formInputs });
  return data;
};

const AdminCreateServicePage = () => {
  
  const { categories } = useSelector((state) => state.getCategories);
  // api types

  const dispatch = useDispatch();

  return (
    <CreateServicePageComponent
      createServiceApiRequest={createServiceApiRequest}
      uploadImagesApiRequest={uploadImagesApiRequest}
      uploadImagesCloudinaryApiRequest={uploadImagesCloudinaryApiRequest}
      categories={categories}
      reduxDispatch={dispatch}
      newCategory={newCategory}
      deleteCategory={deleteCategory}
      saveAttributeToCatDoc={saveAttributeToCatDoc}
    />
  );
};

export default AdminCreateServicePage;
